module.exports = __webpack_public_path__ + "static/media/play-store.88df8c52.png";